import { Component, OnInit } from '@angular/core';
import { LocalStorage } from 'src/app/core/localstorage';
import { TokenService } from 'src/app/core/services/token.service';

@Component({
    selector: 'app-dev-toolbar',
    templateUrl: './dev-toolbar.component.html',
    styleUrls: ['./dev-toolbar.component.scss'],
})
export class DevToolbarComponent implements OnInit {
    host: string;
    constructor(public tokenService: TokenService, private localStorage: LocalStorage) {
        this.host = tokenService.host;
    }

    ngOnInit(): void {}

    async changeHost() {
        this.tokenService.host = this.host;
        this.localStorage.resetLangs();
        this.localStorage.resetToken();
        const response: any = await this.tokenService.refreshToken().toPromise();
        if (response.status_code === 0) {
            window.location.href = window.location.origin;
            // this.router.navigate(['/home']);
        }
    }
}
